import enUs from "./locales/en-us.json";
import daDk from "./locales/da-dk.json";
import deDe from "./locales/de-de.json";
import enGb from "./locales/en-gb.json";
import esEs from "./locales/es-es.json";
import esUs from "./locales/es-us.json";
import fiFi from "./locales/fi-fi.json";
import frCa from "./locales/fr-ca.json";
import frFr from "./locales/fr-fr.json";
import itIt from "./locales/it-it.json";
import nbNo from "./locales/nb-no.json";
import nlNl from "./locales/nl-nl.json";
import ptPt from "./locales/pt-pt.json";
import svSe from "./locales/sv-se.json";
const resources = {
    // en-US is the source language.
    "en-us": enUs,
    "da-dk": daDk,
    "de-at": deDe,
    "de-ch": deDe,
    "de-de": deDe,
    "en-au": enGb,
    "en-ca": enUs,
    "en-gb": enGb,
    "en-ie": enGb,
    "en-in": enGb,
    "en-nz": enGb,
    "en-sg": enGb,
    "es-es": esEs,
    "es-us": esUs,
    "fi-fi": fiFi,
    "fr-ca": frCa,
    "fr-be": frFr,
    "fr-ch": frFr,
    "fr-fr": frFr,
    "it-ch": itIt,
    "it-it": itIt,
    "nb-no": nbNo,
    "nl-be": nlNl,
    "nl-nl": nlNl,
    "pt-pt": ptPt,
    "sv-se": svSe,
};
export const getLocalizationsFor = (locale) => {
    return resources[locale.toLowerCase()];
};
//# sourceMappingURL=index.js.map